import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'
// import { Message } from '@element-plus/icons-vue'  // 注意：Message 应该从 element-plus 导入，而不是 icons

const whiteList = ['/login', '/auth-redirect']

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 确定用户是否已登录
  const hasToken = getToken()
  const isLoggedIn = store.getters.roles && store.getters.roles.length > 0

  // 处理根路径的动态重定向（合并过来的逻辑）
  if (to.path === '/') {
    if (!hasToken) {
      // 未登录，跳转登录页
      next('/login')
      return
    }
    // 已登录但 roles 尚未加载，需要先获取用户信息
    if (!isLoggedIn) {
      try {
        const { roles } = await store.dispatch('user/getInfo')
        // 根据第一个角色重定向
        const roleMap = {
          'admin': '/dashboard/admin',
          'agent': '/dashboard/agent',
          'customer': '/dashboard/customer'
        }
        const target = roleMap[roles[0]] || '/dashboard/admin'
        next(target)
        return
      } catch (error) {
        await store.dispatch('user/resetToken')
        // Message.error(error || '获取用户信息失败')
        ElMessage.error(error || '获取用户信息失败')
        next(`/login?redirect=${to.path}`)
        return
      }
    }
    // 已有 roles，直接重定向
    const roleMap = {
      'admin': '/dashboard/admin',
      'agent': '/dashboard/agent',
      'customer': '/dashboard/customer'
    }
    const target = roleMap[store.getters.roles[0]] || '/dashboard/admin'
    next(target)
    return
  }

  // 其余路径的正常鉴权逻辑（保持原有 guard.js 内容，但略作优化）
  if (hasToken) {
    if (to.path === '/login') {
      // 如果已登录，重定向到首页
      next({ path: '/' })
    } else {
      if (isLoggedIn) {
        next()
      } else {
        try {
          // 获取用户信息
          const { roles } = await store.dispatch('user/getInfo')
          
          // 基于角色生成可访问的路由
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          
          // 动态添加可访问路由
          router.addRoutes(accessRoutes)
          
          // 确保addRoutes完整的hack方法
          next({ ...to, replace: true })
        } catch (error) {
          // 移除token并重定向到登录页面
          await store.dispatch('user/resetToken')
          // Message.error(error || 'Has Error')
          ElMessage.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    /* 没有token */
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单中，直接进入
      next()
    } else {
      // 其他没有访问权限的页面被重定向到登录页面
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // 完成进度条等操作
})